import styled from 'styled-components';

const CardBody = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: ${({ theme }) => theme.size.spacing.large.value};
`;

export { CardBody };
